import React from 'react';
import { useTranslation } from 'react-i18next';
import SortOrderSelectBox from 'components/molecules/sort-order-select-box';
import BaseTableNew from 'components/atoms/base-table/new';
import { usePatientCallHistory } from 'infrastructure/hooks/patient/use-call-history';

import { callHistoryColumns } from './cols';
import s from './styles.module.scss';

interface IProps {
  patientGuid: string;
}

const ContactHistoryTable: React.FC<IProps> = (props) => {
  const { patientGuid } = props;
  const { t } = useTranslation();

  const { loading, items, meta, setMeta } = usePatientCallHistory({
    patientGuid,
  });

  return (
    <div>
      <div className={s.header}>
        <h3 className={s.title}>
          {`${t('labels.calls')}: ${meta.totalCount}`}
        </h3>

        <SortOrderSelectBox
          value={meta?.sort}
          minWidth="165px"
          descLabel={t('labels.fromNewToOld')}
          ascLabel={t('labels.fromOldToNew')}
          onChange={(sort) => {
            setMeta({ sort });
          }}
        />
      </div>
      <BaseTableNew
        loading={loading}
        items={items}
        columns={callHistoryColumns()}
        bordered
        pagination={{
          current: meta.page,
          pageSize: meta.items,
          total: meta?.totalCount ?? 0,
          position: ['bottomCenter'],
        }}
        onChangePage={(page) => {
          setMeta({ page });
        }}
      />
    </div>
  );
};

export default ContactHistoryTable;
